import React from "react";
import { Dialog } from "primereact/dialog";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import { getCurrencySymbol } from "../../../../../../utilities/CurrencySwitch";
import { formatExtrapayDateTime } from "../formatExtrapay";
import ExtrapayDetailRows from "./ExtrapayDetailRows";
import ExtrapayDialogHeading from "./ExtrapayDialogHeading";
import ExtrapayInfoNote from "./ExtrapayInfoNote";

const PurchasePointsDialog = ({ purchase, onHide }) => {
  if (!purchase) return null;

  const currencySymbol = getCurrencySymbol(purchase.currency);
  const amount = Number(purchase.amountOrder) || 0;

  return (
    <Dialog
      visible
      onHide={onHide}
      draggable={false}
      className="extrapay-flow-dialog"
      style={{ width: "min(640px, 96vw)" }}
      header={
        <ExtrapayDialogHeading
          title={localeText("extrapayFlowPurchasePointsTitle", { id: purchase.id })}
          subtitle={localeText("extrapayFlowPurchasePointsSubtitle")}
        />
      }
    >
      <ExtrapayDetailRows
        rows={[
          {
            label: localeText("extrapayFlowDate"),
            value: formatExtrapayDateTime(purchase.date),
          },
          {
            label: localeText("extrapayFlowAmountAfterDiscount"),
            value: `${currencySymbol} ${formatPrice(amount)}`,
          },
          {
            label: localeText("extrapayFlowPointsPercent"),
            value: localeText("extrapayFlowPointsPercentValue"),
          },
          {
            label: localeText("extrapayFlowPointsReceived"),
            value: formatPrice(purchase.extrapayPoints),
          },
          {
            label: localeText("extrapayFlowCycle"),
            value: purchase.extrapayCycle,
          },
        ]}
      />
      <div className="mt-3">
        <ExtrapayInfoNote text={localeText("extrapayFlowPurchasePointsNote")} />
      </div>
    </Dialog>
  );
};

export default PurchasePointsDialog;
